import { z } from "zod/v4"
import { VoiceReplyEmoteId, VoiceReplyEmoteIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"
import { UserDenormalizedWithoutLook, Users } from "./user"
import { VoiceEmoteKind } from "./voice-emote"

// ─── VoiceReplyEmoteDocument ─────────────────────────────────────────────────
// Path: users/{userId}/voices/{voiceId}/voice-replies/{voiceReplyId}/voice-reply-emotes/{voiceReplyEmoteId}

export const VoiceReplyEmoteDocumentMeta = z.object({
  user: UserDenormalizedWithoutLook.describe("エモート送信者の非正規化ユーザー情報"),
  kind: VoiceEmoteKind,
})

export type VoiceReplyEmoteDocumentMeta = z.infer<typeof VoiceReplyEmoteDocumentMeta>

export const VoiceReplyEmoteDocumentBody = z.intersection(
  VoiceReplyEmoteDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type VoiceReplyEmoteDocumentBody = z.infer<typeof VoiceReplyEmoteDocumentBody>

export const VoiceReplyEmoteDocument = z.intersection(
  VoiceReplyEmoteDocumentBody,
  z.object({
    id: VoiceReplyEmoteIdSchema,
  })
)

export type VoiceReplyEmoteDocument = z.infer<typeof VoiceReplyEmoteDocument>

export class VoiceReplyEmoteDocuments {

  static toDocumentData(emote: VoiceReplyEmoteDocument): object {
    return {
      ...emote,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): VoiceReplyEmoteDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: VoiceReplyEmoteId(doc.id),
      user: Users.parseDenormalizedWithoutLook(data["user"]),
      kind: data["kind"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

}

// ─── API Request/Response ────────────────────────────────────────────────────

export const CreateVoiceReplyEmoteRequest = z.object({
  kind: VoiceEmoteKind,
})
export type CreateVoiceReplyEmoteRequest = z.infer<typeof CreateVoiceReplyEmoteRequest>

export const CreateVoiceReplyEmoteResponse = z.object({
  id: z.string().describe("作成されたエモートのID"),
})
export type CreateVoiceReplyEmoteResponse = z.infer<typeof CreateVoiceReplyEmoteResponse>
